import OrderDetailsPage from './OrderDetailsPage'

export default OrderDetailsPage
